import { render } from "./singleRental.vue?vue&type=template&id=af832b84&scoped=true"
import script from "./singleRental.vue?vue&type=script&lang=js"
export * from "./singleRental.vue?vue&type=script&lang=js"

import "./singleRental.vue?vue&type=style&index=0&id=af832b84&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af832b84"]])

export default __exports__